
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Contacts from "../pages/contacts/page";
import Services from "../pages/services/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/contacts",
    element: <Contacts />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
